module.exports = __webpack_public_path__ + "static/media/woah.09fb21c5.wav";